/* =========================
     REFRESH CART SECTION
  ==========================*/
        $(".js-toggle-slide-nav").on("click",function() {
$('body').toggleClass('menu_open');
    
});
  function refreshCartSection(){
  $.ajax({
            url: "/",
            type: "GET",
            dataType: "html",
            success: function(data) {
              $('.free-shipping-bar').html($(data).closest('.free-shipping-bar').html());
              $('.bundle_wrap_products').html($(data).closest('.bundle_wrap_products').html());
                            $('.discount-bar').html($(data).closest('.discount-bar').html());
                                                        $('.cart_footer_updated').html($(data).closest('.cart_footer_updated').html());



            },


          });
  }
/* =========================
   FREE GIFT LOGIC (A → B)
==========================*/

function handleFreeGift() {
  if (!window.FREE_GIFT || !FREE_GIFT.enabled) return;
  $.getJSON('/cart.js', function (cart) {

    let hasTriggerProduct = false;
    let giftItemKey = null;

    cart.items.forEach(function (item) {

      if (item.product_id == FREE_GIFT.triggerProductId) {
        hasTriggerProduct = true;
      }

      if (item.variant_id == FREE_GIFT.giftVariantId) {
        giftItemKey = item.key;
      }

    });

    /* ADD GIFT */
    if (hasTriggerProduct && !giftItemKey) {

      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          id: FREE_GIFT.giftVariantId,
          quantity: 1,
          properties: { "_free_gift": "true" }
        },
        dataType: 'json',
        success: function () {
               document.dispatchEvent(new CustomEvent('cart:build'));
          refreshCartSection(); // 🔥 SAME AS SHIPPING BAR
        }
      });

    }

    /* REMOVE GIFT */
    if (!hasTriggerProduct && giftItemKey) {

      // $.ajax({
      //   type: 'POST',
      //   url: '/cart/change.js',
      //   data: {
      //     id: giftItemKey,
      //     quantity: 0
      //   },
      //   dataType: 'json',
      //   success: function () {
      //          document.dispatchEvent(new CustomEvent('cart:build'));
      //     refreshCartSection(); // 🔥 SAME AS SHIPPING BAR
      //   }
      // });

    }

  });
}


    const originalFetch = window.fetch;
    window.fetch = function() {
      return originalFetch.apply(this, arguments).then(response => {
        if (arguments[0].includes('/cart/add') || arguments[0].includes('/cart/change') || arguments[0].includes('/cart/update')) {
          // Small delay to let the theme finish its own update
                   refreshCartSection();
                     setTimeout(handleFreeGift, 300); // 🔥 FREE GIFT CHECK


        }
        return response;
      });
    };


  function startLoading($btn, $text, $loader){
  $btn.addClass('loading').prop('disabled', true);
  $text.hide();
  $loader.show();

  // 🔥 FORCE repaint so loader appears immediately
  $btn[0].offsetHeight;
}
function stopLoading($btn, $text, $loader){
  $btn.removeClass('loading').prop('disabled', false);
  $text.show();
  $loader.hide();
}


$(document).on('click', '.apply-discount-btn', function () {

  var $btn = $(this);
  var $text = $btn.find('.btn-text');
  var $loader = $btn.find('.btn-loader');
  var $input = $('#discount-code');
  var $error = $('.discount-error');

  var code = $input.val().trim();
  if (!code) return;

  $error.hide();
  $input.removeClass('error');

  startLoading($btn, $text, $loader);

  // 1️⃣ Apply discount
  $.ajax({
    type: 'POST',
    url: '/cart/update.js',
    data: JSON.stringify({ discount: code }),
    contentType: 'application/json'
  })
  .done(function () {

    // 2️⃣ Fetch cart safely
    $.getJSON('/cart.js', function (cart) {
      console.log(cart);

      // 3️⃣ Validate discount — check discount_codes array for applicable entry
      var discountValid = cart.discount_codes &&
                          cart.discount_codes.length > 0 &&
                          cart.discount_codes.some(function(d) {
                            return d.applicable === true;
                          });

      if (!discountValid) {
        stopLoading($btn, $text, $loader);
        $input.addClass('error');
        $error.show();
        return;
      }

      // ✅ Discount applied — rebuild cart drawer first, then refresh
      stopLoading($btn, $text, $loader);
      document.dispatchEvent(new CustomEvent('cart:build'));
    });

  })
  .fail(function (err) {
    console.log('Apply error:', err);
    stopLoading($btn, $text, $loader);
  });

});


$(document).on('click', '.remove-discount', function () {

  var $btn = $(this);
  var $text = $btn.find('.btn-text');
  var $loader = $btn.find('.btn-loader');

  startLoading($btn, $text, $loader);

  $.ajax({
    type: 'POST',
    url: '/cart/update.js',
    data: JSON.stringify({ discount: '' }),
    contentType: 'application/json',
    success: function () {
      refreshCartSection();
    }
  });
});

$(document).ready(function () {
  handleFreeGift();

 const circles = $('.video-circle');
  let currentIndex = 0;

function playVideo(index) {
  if (!circles.length) return; // no circles

  circles.removeClass('active');

  circles.find('video').each(function () {
    this.pause();
    this.currentTime = 0;
  });

  const circle = circles.eq(index);
  if (!circle.length) return; // invalid index

  const video = circle.find('video').get(0);
  if (!video) return; // no video found

  circle.addClass('active');

  video.play().catch(function(error){
    console.log("Autoplay prevented:", error);
  });

  currentIndex = index;
}


  // autoplay first video
if (circles.length > 0) {
  playVideo(0);
}


  // play next when finished
  circles.find('video').on('ended', function () {
    let next = currentIndex + 1;
    if (next >= circles.length) next = 0;
    playVideo(next);
  });

  // click → open modal
  circles.on('click', function () {
    const index = $(this).data('index');
    const src = $(this).find('source').attr('src');

    const modalVideo = $('.pdp-video-modal video').get(0);
    modalVideo.src = src;
    modalVideo.play();

    $('.pdp-video-modal').fadeIn(200);
    playVideo(index);
  });

  // close modal
  $('.modal-close, .modal-overlay').on('click', function () {
    const modalVideo = $('.pdp-video-modal video').get(0);
    modalVideo.pause();
    modalVideo.currentTime = 0;
    $('.pdp-video-modal').fadeOut(200);
  });
 $(document).on('click', '.read-more-toggle', function () {
    var $wrapper = $(this).closest('.read-more-wrapper');
    var $short = $wrapper.find('.read-more-short');
    var $full = $wrapper.find('.read-more-full');
    var check_button_more = $(".read-more-toggle").attr('data-more');
    var check_button_less = $(".read-more-toggle").attr('data-less');
    if ($full.is(':visible')) {
      $full.hide();
      $short.show();
      $(this).text(check_button_more);
    } else {
      $short.hide();
      $full.show();
      $(this).text(check_button_less);
    }
  });



  var $button = $("#atc-test-id");

  $button.on("click", function () {

    var $before = $(this).find(".before_clicked_text");
    var $after  = $(this).find(".clicked_text");

    // Switch text
    $before.hide();
    $after.show();

    // Switch back after 1 second
    setTimeout(function () {
      $after.hide();
      $before.show();
    }, 1000);

  });

});
$(document).on('change', '#bundleProduct', function () {
    loadBundleProduct($(this).val());
});
function parsePrice(priceString) {
  if (!priceString) return 0;
  return parseFloat(
    priceString
      .replace(/[^\d,]/g, '') // remove € and text
      .replace(',', '.')      // convert comma to dot
  );
}
function loadBundleProduct(handle) {

    const productBlock = $('.products_wrap_inner[data-handle="' + handle + '"]');
    if (!productBlock.length) return;

    let image = productBlock.data('image');
    let priceStr = productBlock.data('price');       // "€ 79,99"
    let compareStr = productBlock.data('compare');   // optional
    let variantId = productBlock.data('id');

    $('#variantContainer').html('');

    const variantSelect = productBlock.find('.bundlevariants');

    // VARIANTS
    if (variantSelect.length) {

        const clone = variantSelect.clone().show();
        $('#variantContainer').html(clone);

        const firstOption = clone.find('option:selected');

        image = firstOption.data('image') || image;
        priceStr = firstOption.data('price');
        compareStr = firstOption.data('compare');
        variantId = firstOption.data('id');
    }

    // PARSE PRICES
    const price = parsePrice(priceStr);
    const discountPerc = parseFloat($('.discount_perc').val()) || 0;
    const discountedPrice = price - (price * discountPerc / 100);

    // IMAGE
    $('#bundleSecondImage').attr('src', image);

    // PRICE HTML (ONE LINE)
    $('#bundlePrice').html(`
      <span class="bundle-compare-price">€ ${price.toFixed(2).replace('.', ',')}</span>
      <span class="bundle-sale-price">€ ${discountedPrice.toFixed(2).replace('.', ',')}</span>
    `);

    $('#bundleAddToCart').attr('data-id', variantId);
}



// VARIANT CHANGE
$(document).on('change', '#variantContainer .bundlevariants', function () {

    const opt = $(this).find('option:selected');

    // IMAGE
    if (opt.data('image')) {
        $('#bundleSecondImage').attr('src', opt.data('image'));
    }

    // PRICE LOGIC
    const priceStr = opt.data('price'); // "€ 79,99"
    const price = parsePrice(priceStr);

    const discountPerc = parseFloat($('.discount_perc').val()) || 0;
    const discountedPrice = price - (price * discountPerc / 100);

    // UPDATE PRICE (ONE LINE)
    $('#bundlePrice').html(`
      <span class="bundle-compare-price">€ ${price.toFixed(2).replace('.', ',')}</span>
      <span class="bundle-sale-price">€ ${discountedPrice.toFixed(2).replace('.', ',')}</span>
    `);

    // VARIANT ID
    $('#bundleAddToCart').attr('data-id', opt.data('id'));

});


// INITIAL LOAD (cart drawer opens)
$(document).ready(function(){
    loadBundleProduct($('#bundleProduct').val());
});


$(document).on('click', '#bundleAddToCart', function(){

    const variantId = $(this).data('id');
        $(this).addClass('btn--loading');
        $(this).css('opacity','0.5');
                $(this).css('pointer-events','none');
$(this).text('Adding..');
    if(!variantId) return;

    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
            id: variantId,
            quantity: 1
        },
        dataType: 'json',
        success: function () {

            // refresh cart drawer (works in most themes)
          // THIS is what your theme listens to
      

      document.dispatchEvent(new CustomEvent('cart:build'));
window.scrollTo({ top: 0, behavior: 'smooth' });
          refreshCartSection(); // 🔥 SAME AS SHIPPING BAR

        $('#bundleAddToCart').removeClass('btn--loading');

        }
    });

});